<template>
  <mp-flex v-if="contributors.length" flex-direction="column" mt="3">
    <mp-flex
      v-for="user in contributorsPaginated"
      :key="user.id"
      align-items="center"
      p="2"
      border-bottom-color="gray.100"
      :border-bottom-width="contributors.length > 1 ? 'sm' : 0"
      gap="3"
    >
      <mp-avatar :src="user.url_avatar || user.avatar" :name="`${user.first_name} ${user.last_name}`" w="36px" h="36px" />
      <mp-box>
        <mp-text
          >{{ user.first_name }} {{ user.last_name }}<template v-if="loggedInUser && user.id === loggedInUser.id"> (Default)</template></mp-text
        >
        <mp-text font-size="sm" color="gray.600">
          {{ getContributorInfo(user) }}
        </mp-text>
      </mp-box>
      <mp-button-icon v-if="!isPreviewOnly" ml="auto" flex-shrink="0" name="minus-circular" @click="$emit('remove', user.id)" />
    </mp-flex>
    <pagination v-if="!isNoNeedPagination" :is-row="false" :metas="metas" @update="updatePagination" />
  </mp-flex>
</template>

<script>
import Pagination from '@/components/Pagination';

export default {
  name: 'ContributorList',
  components: { Pagination },
  props: {
    contributors: {
      type: Array,
      required: true,
    },
    loggedInUser: {
      type: Object,
      default: null,
    },
    perPage: {
      type: Number,
      default: 5,
    },
    isPreviewOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      metas: {
        current_page: 1,
        last_page: 1,
        per_page: this.perPage,
        from: 1,
        to: 1,
        total: 0,
      },
    };
  },
  watch: {
    contributors: {
      handler(val) {
        this.metas.total = val.length;
        this.metas.last_page = Math.ceil(this.metas.total / this.metas.per_page);
      },
      immediate: true,
    },
    contributorsPaginated(val) {
      if (!val.length && this.metas.current_page !== 0) this.metas.current_page -= 1;

      if (this.isNoNeedPagination) {
        this.metas.current_page = 1;
        this.metas.from = 1;
        this.metas.to = this.contributors.length;
      }
    },
  },
  computed: {
    isNoNeedPagination() {
      return this.contributors.length <= this.metas.per_page;
    },
    contributorsPaginated() {
      if (this.isNoNeedPagination) return this.contributors;
      return this.contributors.slice((this.metas.current_page - 1) * this.metas.per_page, this.metas.current_page * this.metas.per_page);
    },
  },
  methods: {
    updatePagination(obj) {
      this.metas.current_page = obj.page;
      this.metas.from = (obj.page - 1) * this.metas.per_page + 1;
      this.metas.to = Math.min(obj.page * this.metas.per_page, this.metas.total);
    },
    getContributorInfo(user) {
      const info = [];
      if (user.id_employee) info.push(user.id_employee);
      if (user.organization) {
        if (user.organization.organization) {
          info.push(user.organization.organization);
        } else {
          info.push(user.organization);
        }
      }
      if (user.job) {
        if (user.job.job) {
          info.push(user.job.job);
        } else {
          info.push(user.job);
        }
      }
      return info.join(' | ');
    },
  },
};
</script>
